import { ErrorCode } from './../../../../../../../../../server/entity/error-code';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { finalize } from 'rxjs/operators';
import { bookingDetailPickUpChangeRequest } from 'src/app/core/models/transport-operation/booking-detail-pickup-change-request';

@Component({
  selector: 'laas-booking-detail-pickup-change',
  templateUrl: './booking-detail-pickup-change.component.html',
  styleUrls: ['./booking-detail-pickup-change.component.scss'],
})
export class BookingDetailPickupChangeComponent
  extends SessionBaseComponent
  implements OnInit
{
  @Input() booking: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() bookingDetailPickUpChangeSaved: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;
  @Input() isNeedShowPicking: boolean;
  readonly preferenceKey: string;
  isVisible: boolean;
  pickUpcolumns: any[];
  selectedPicUpCols: any[];
  selectedRows: any[];
  isAutoChangingDoNoStatusOptions: any[];
  DOStatusOptions: any[];
  newStatusOptions: any[];
  tmpDetails: any[];
  isLoading: boolean;
  selectedPickingType: any;
  selectedPickingText: any;
  noPickingDoOptions: any[];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private bookingService: BookingService
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.BookingDetailPickUpStatusChange;
    this.isVisible = false;
    this.booking = null;
    this.tmpDetails = [];
    this.pickUpcolumns = [
      { field: 'noPickingDo', header: '揀貨狀態' },
      { field: 'doNo', header: this.translateService.instant('DeliveryOrder.DoNo') },
      { field: 'doStatus', header: 'doStatus' },
    ];
    this.selectedPicUpCols = this.pickUpcolumns;
    this.selectedRows = [];
    this.isAutoChangingDoNoStatusOptions = [];
    this.DOStatusOptions = [];
    this.newStatusOptions = [];
    this.isLoading = false;
    this.visibleChange = new EventEmitter<any>();
    this.bookingDetailPickUpChangeSaved = new EventEmitter<any>();
    this.isNeedShowPicking = false;
    this.selectedPickingType = '0';
    this.selectedPickingText = this.translateService.instant(
      'BookingPreview.DOList.ChangePickText'
    );
    this.noPickingDoOptions = [
      { label: '揀貨', value: '0' },
      { label: '不揀貨', value: '1' },
    ];
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.tmpDetails = isNullOrEmpty(this.booking?.bookingDetails)
      ? []
      : deepCopy(this.booking.bookingDetails);
    this.tmpDetails.forEach((x) => (x.isAutoChangingDoNoStatus = '1'));
    console.log(this.tmpDetails);
    this.commonDataService
      .getCodeConverter(this.laasSetting.language, 'DropdownList', 'DoStatus')
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map((x) => ({
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          }));
        },
      });
    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'ChooseYesOrNo'
      )
      .subscribe({
        next: (options: any[]) => {
          this.isAutoChangingDoNoStatusOptions = options.map((x) => ({
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          }));
        },
      });
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  confirmBtnClick(event: any): void {
    let noPickDoNos: string[] = [];
    let pickDoNos: string[] = [];
    for (const rowVal of this.tmpDetails) {
      console.log('rowVal:',rowVal);
      for (const cloneRowVal of this.booking?.bookingDetails) {
        console.log('cloneRowVal:', cloneRowVal);
        if (rowVal.doNo == cloneRowVal.doNo) {
          console.log('rowVal.doNo', rowVal.doNo,'cloneRowVal.doNo', cloneRowVal.doNo);
          console.log('rowVal.noPickingDo', rowVal.noPickingDo, 'cloneRowVal.noPickingDo' , cloneRowVal.noPickingDo);
          if (rowVal.noPickingDo != cloneRowVal.noPickingDo) {
            if (rowVal.noPickingDo == '1') {
              noPickDoNos.push(rowVal.doNo);
            } else {
              pickDoNos.push(rowVal.doNo);
            }
          }
        }
      }
    }

    this.isLoading = true;
    if (noPickDoNos.length > 0 || pickDoNos.length > 0) {
      const updateObj = {
        bookingNo: this.booking.bookingNo,
        noPickdoNoList: noPickDoNos,
        pickDoNoList: pickDoNos,
        updateUser: this.userProfile.userName,
        facility: this.laasSetting.facility,
      };
      this.bookingService
        .updateBookingDetailDoPickUpFlag(updateObj)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: (result) => {
            let showMessage = '';
            if (
              result.checkStatus == 'E' &&
              !isNullOrEmpty(result.errorString)
            ) {
              for (const message of result.errorString) {
                showMessage = showMessage + message + '\n';
              }
              this.toastErrorMessage(showMessage);
            } else {
              this.dialog.close(event);
              this.bookingDetailPickUpChangeSaved.emit({ originalEvent: event });
            }
          },
          error: (err) => {
            this.toastErrorMessage(err.error);
          },
        });
    } else {
      this.dialog.close(event);
      this.bookingDetailPickUpChangeSaved.emit({ originalEvent: event });
    }

  }

  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split(',').filter((x) => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  getNewStatusOptions(rowData: any): any {
    return this.DOStatusOptions.filter((x) => x.value !== rowData.status);
  }

  selectedPicking($event: any) {
    this.selectedRows
      .filter((x: any) =>
        this.booking.bookingDetails.some((y: any) => y.doNo === x.doNo)
      )
      .forEach((x: any) => {
        x.noPickingDo = x.noPickingDo == '0' ? '1' : '0';
      });
  }
}
